const initialState = {
    list: [],
    count:{},
    query: "",
    sorting: {
        column: "dueDate",
        order: "desc"
    },
    filters: {}
}

export default function reducer(
    state = initialState,
    action
) {
    switch (action.type) {
        case "UPDATE_MILESTONE_LIST": 
            return {
                ...state,
                list: action.list,
                count:action.count
            }

        case "UPDATE_MILESTONE_QUERY":
            return {
                ...state,
                query: action.query
            }
        
        case "SET_MILESTONE_SORTING":
            return {
                ...state,
                sorting: action.sorting
            }

        case "SET_MILESTONE_FILTERS":
            return {
                ...state,
                filters: {
                    ...state.filters,
                    [action.column]: action.filters
                }
            }

        default:
            return state;
    }
}
